import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import '../../../../styles/scss/style.css';

import TextHeadingOne from '../../atoms/TextHeadingOne';
import TextParagraph from '../../atoms/TextParagraph';
import FormButton from '../../atoms/FormButton';
import Modal from '../Modal';
import { ROOT_URL } from '../../../config/global.js';
import { strings } from './content';

class FormDeleteIntent extends Component {
	state = {}
	deleteSubjectHandler = (e) => {
		e.preventDefault();
		const deleteSubjectRequest = axios({
            method: 'delete',
            url: `${ROOT_URL}/api/intents/${this.props.id}`
        });

    deleteSubjectRequest.then((subjectReqAnswer) => window.location.reload());
	}
	render() {
		return (
			<Modal modalClass={this.props.modalClass} onClick={this.props.onClickCancel}>
				<form className={`form formDeleteBot ${this.props.formWrapperClassType}`}>
					<TextHeadingOne text={strings.heading} />
					<TextParagraph text={strings.paragraph} />
					<div className="formDeleteBot__infoBox">
						<div className="formDeleteBot__info">
							<TextParagraph classType="formDeleteBot__data" text={strings.paragraph2} />
							<TextParagraph text={this.props.value} />
						</div>
					</div>
					<div className="btnRow">
					<FormButton text={strings.button.text} onClick={this.deleteSubjectHandler} />
					<FormButton text={strings.button.textCancel} onClick={this.props.onClickCancel} />
					</div>
				</form>
			</Modal>
		)
	}
}

export default withRouter(FormDeleteIntent);


// WEBPACK FOOTER //
// ./src/redux/components/organisms/FormDeleteIntent/index.jsx